/**
 * Shared guard for global keyboard shortcuts.
 *
 * The naive check is `event.target === document.body`, which is wrong twice
 * over: it swallows the shortcut whenever focus happens to sit on a button
 * (which it does immediately after you click one), and it silently does
 * nothing for events dispatched at window.
 *
 * What actually matters is whether the user is typing into something.
 */

const TYPING = new Set(["INPUT", "TEXTAREA", "SELECT"]);

export function isTypingTarget(event) {
  const target = event.target;
  if (!target || typeof target.tagName !== "string") return false;
  if (TYPING.has(target.tagName)) return true;
  return target.isContentEditable === true;
}

/** True when a plain, unmodified key press should trigger a shortcut. */
export function isShortcut(event) {
  if (event.metaKey || event.ctrlKey || event.altKey) return false;
  return !isTypingTarget(event);
}
